import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'stateGuide'
})
export class StateGuidePipe implements PipeTransform {

    transform(stateId) {
        return stateId;
    }

}